import { all, el, one, type Target } from './dom';

export type AlertMode = 'success' | 'warning' | 'danger' | 'info' | string;

const icons: Record<string, string> = {
    success: 'fas fa-check-circle text-success',
    warning: 'fas fa-exclamation-triangle text-warning',
    danger: 'fas fa-times-circle text-danger',
};

export function iconFor(mode: AlertMode): string {
    return icons[mode] ?? 'fas fa-info-circle text-primary';
}

/**
 * Render a dismissable Bootstrap alert into a container, replacing whatever
 * it held. Both messages are text, never markup -- the second line commonly
 * echoes a server statusText or a user-supplied value.
 */
export function setAlertMessage(container: Target, mode: AlertMode, message1?: string | null, message2?: string | null): void {
    const host = one(container);
    if (!host) return;

    const alert = el('div', `alert alert-${mode} alert-dismissable fade show`);
    alert.setAttribute('role', 'alert');
    alert.appendChild(el('i', `${iconFor(mode)} fs-2 me-2 float-start`));
    alert.appendChild(el('span', 'align-middle alert-heading fw-bold', message1 ?? ''));
    alert.appendChild(document.createTextNode(' '));
    const close = el('button', 'btn-close float-end');
    close.type = 'button';
    close.setAttribute('data-bs-dismiss', 'alert');
    close.setAttribute('aria-label', 'Close');
    alert.appendChild(close);
    if (message2) alert.appendChild(el('p', undefined, message2));

    host.replaceChildren(alert);
}

/** Clear every alert previously rendered into the container(s). */
export function clearAlerts(container: Target): void {
    for (const host of all(container)) host.replaceChildren();
}
